import { render, staticRenderFns } from "./PublisherCommitment.vue?vue&type=template&id=631790cc&scoped=true&"
import script from "./PublisherCommitment.vue?vue&type=script&lang=js&"
export * from "./PublisherCommitment.vue?vue&type=script&lang=js&"
import style0 from "./PublisherCommitment.vue?vue&type=style&index=0&id=631790cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631790cc",
  null
  
)

export default component.exports